import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var BellOff = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "currentColor",
    };
    return (React.createElement(StyledIconBase, tslib_1.__assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("path", { d: "M12 22a2.98 2.98 0 0 0 2.818-2H9.182A2.98 2.98 0 0 0 12 22zm8.006-4.095a1 1 0 0 0 .805-1.611l-.823-1.625-.017-2.763c-.027-4.553-2.48-7.905-6.157-8.742A1.99 1.99 0 0 0 12 2a1.99 1.99 0 0 0-1.803 1.144A7.36 7.36 0 0 0 6.54 5.126L3.707 2.293 2.293 3.707l18 18 1.414-1.414-2.384-2.384.683-.004zM4.458 8.625A11.122 11.122 0 0 0 3.971 12l.017 2.764-.884 1.795a.999.999 0 0 0 .903 1.442l9.879-.059-9.428-9.317z", key: "k0" })));
});
BellOff.displayName = 'BellOff';
export var BellOffDimensions = { height: 24, width: 24 };
